/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.19.1
 * source: testsystem/v1/events/events.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../../../google/protobuf/timestamp";
import * as dependency_2 from "./../common/common";
import * as dependency_3 from "./../entities/test_case";
import * as dependency_4 from "./../entities/test_suite";
import * as dependency_5 from "./../../../google/protobuf/duration";
import * as pb_1 from "google-protobuf";
export namespace testsystem.v1.events {
    export class TestBeginEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            test_case?: dependency_3.testsystem.v1.entities.TestCaseRun;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("test_case" in data && data.test_case != undefined) {
                    this.test_case = data.test_case;
                }
            }
        }
        get test_case() {
            return pb_1.Message.getWrapperField(this, dependency_3.testsystem.v1.entities.TestCaseRun, 1) as dependency_3.testsystem.v1.entities.TestCaseRun;
        }
        set test_case(value: dependency_3.testsystem.v1.entities.TestCaseRun) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get has_test_case() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            test_case?: ReturnType<typeof dependency_3.testsystem.v1.entities.TestCaseRun.prototype.toObject>;
        }): TestBeginEventRequest {
            const message = new TestBeginEventRequest({});
            if (data.test_case != null) {
                message.test_case = dependency_3.testsystem.v1.entities.TestCaseRun.fromObject(data.test_case);
            }
            return message;
        }
        toObject() {
            const data: {
                test_case?: ReturnType<typeof dependency_3.testsystem.v1.entities.TestCaseRun.prototype.toObject>;
            } = {};
            if (this.test_case != null) {
                data.test_case = this.test_case.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_test_case)
                writer.writeMessage(1, this.test_case, () => this.test_case.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TestBeginEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TestBeginEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.test_case, () => message.test_case = dependency_3.testsystem.v1.entities.TestCaseRun.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): TestBeginEventRequest {
            return TestBeginEventRequest.deserialize(bytes);
        }
    }
    export class TestEndEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            test_case?: dependency_3.testsystem.v1.entities.TestCaseRun;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("test_case" in data && data.test_case != undefined) {
                    this.test_case = data.test_case;
                }
            }
        }
        get test_case() {
            return pb_1.Message.getWrapperField(this, dependency_3.testsystem.v1.entities.TestCaseRun, 1) as dependency_3.testsystem.v1.entities.TestCaseRun;
        }
        set test_case(value: dependency_3.testsystem.v1.entities.TestCaseRun) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get has_test_case() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            test_case?: ReturnType<typeof dependency_3.testsystem.v1.entities.TestCaseRun.prototype.toObject>;
        }): TestEndEventRequest {
            const message = new TestEndEventRequest({});
            if (data.test_case != null) {
                message.test_case = dependency_3.testsystem.v1.entities.TestCaseRun.fromObject(data.test_case);
            }
            return message;
        }
        toObject() {
            const data: {
                test_case?: ReturnType<typeof dependency_3.testsystem.v1.entities.TestCaseRun.prototype.toObject>;
            } = {};
            if (this.test_case != null) {
                data.test_case = this.test_case.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_test_case)
                writer.writeMessage(1, this.test_case, () => this.test_case.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TestEndEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TestEndEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.test_case, () => message.test_case = dependency_3.testsystem.v1.entities.TestCaseRun.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): TestEndEventRequest {
            return TestEndEventRequest.deserialize(bytes);
        }
    }
    export class StepBeginEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            step?: dependency_3.testsystem.v1.entities.StepRun;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("step" in data && data.step != undefined) {
                    this.step = data.step;
                }
            }
        }
        get step() {
            return pb_1.Message.getWrapperField(this, dependency_3.testsystem.v1.entities.StepRun, 1) as dependency_3.testsystem.v1.entities.StepRun;
        }
        set step(value: dependency_3.testsystem.v1.entities.StepRun) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get has_step() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            step?: ReturnType<typeof dependency_3.testsystem.v1.entities.StepRun.prototype.toObject>;
        }): StepBeginEventRequest {
            const message = new StepBeginEventRequest({});
            if (data.step != null) {
                message.step = dependency_3.testsystem.v1.entities.StepRun.fromObject(data.step);
            }
            return message;
        }
        toObject() {
            const data: {
                step?: ReturnType<typeof dependency_3.testsystem.v1.entities.StepRun.prototype.toObject>;
            } = {};
            if (this.step != null) {
                data.step = this.step.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_step)
                writer.writeMessage(1, this.step, () => this.step.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StepBeginEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StepBeginEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.step, () => message.step = dependency_3.testsystem.v1.entities.StepRun.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): StepBeginEventRequest {
            return StepBeginEventRequest.deserialize(bytes);
        }
    }
    export class StepEndEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            step?: dependency_3.testsystem.v1.entities.StepRun;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("step" in data && data.step != undefined) {
                    this.step = data.step;
                }
            }
        }
        get step() {
            return pb_1.Message.getWrapperField(this, dependency_3.testsystem.v1.entities.StepRun, 1) as dependency_3.testsystem.v1.entities.StepRun;
        }
        set step(value: dependency_3.testsystem.v1.entities.StepRun) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get has_step() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            step?: ReturnType<typeof dependency_3.testsystem.v1.entities.StepRun.prototype.toObject>;
        }): StepEndEventRequest {
            const message = new StepEndEventRequest({});
            if (data.step != null) {
                message.step = dependency_3.testsystem.v1.entities.StepRun.fromObject(data.step);
            }
            return message;
        }
        toObject() {
            const data: {
                step?: ReturnType<typeof dependency_3.testsystem.v1.entities.StepRun.prototype.toObject>;
            } = {};
            if (this.step != null) {
                data.step = this.step.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_step)
                writer.writeMessage(1, this.step, () => this.step.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StepEndEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StepEndEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.step, () => message.step = dependency_3.testsystem.v1.entities.StepRun.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): StepEndEventRequest {
            return StepEndEventRequest.deserialize(bytes);
        }
    }
    export class TestFailureEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            test_id?: string;
            failure_message?: string;
            stack_trace?: string;
            timestamp?: dependency_1.google.protobuf.Timestamp;
            attachments?: dependency_2.testsystem.v1.common.Attachment[];
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("test_id" in data && data.test_id != undefined) {
                    this.test_id = data.test_id;
                }
                if ("failure_message" in data && data.failure_message != undefined) {
                    this.failure_message = data.failure_message;
                }
                if ("stack_trace" in data && data.stack_trace != undefined) {
                    this.stack_trace = data.stack_trace;
                }
                if ("timestamp" in data && data.timestamp != undefined) {
                    this.timestamp = data.timestamp;
                }
                if ("attachments" in data && data.attachments != undefined) {
                    this.attachments = data.attachments;
                }
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("retry_index" in data && data.retry_index != undefined) {
                    this.retry_index = data.retry_index;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
        }
        get test_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set test_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get failure_message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set failure_message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get stack_trace() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set stack_trace(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get timestamp() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 4) as dependency_1.google.protobuf.Timestamp;
        }
        set timestamp(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get has_timestamp() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get attachments() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_2.testsystem.v1.common.Attachment, 5) as dependency_2.testsystem.v1.common.Attachment[];
        }
        set attachments(value: dependency_2.testsystem.v1.common.Attachment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 5, value);
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get retry_index() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set retry_index(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            test_id?: string;
            failure_message?: string;
            stack_trace?: string;
            timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            attachments?: ReturnType<typeof dependency_2.testsystem.v1.common.Attachment.prototype.toObject>[];
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }): TestFailureEventRequest {
            const message = new TestFailureEventRequest({});
            if (data.test_id != null) {
                message.test_id = data.test_id;
            }
            if (data.failure_message != null) {
                message.failure_message = data.failure_message;
            }
            if (data.stack_trace != null) {
                message.stack_trace = data.stack_trace;
            }
            if (data.timestamp != null) {
                message.timestamp = dependency_1.google.protobuf.Timestamp.fromObject(data.timestamp);
            }
            if (data.attachments != null) {
                message.attachments = data.attachments.map(item => dependency_2.testsystem.v1.common.Attachment.fromObject(item));
            }
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.retry_index != null) {
                message.retry_index = data.retry_index;
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                test_id?: string;
                failure_message?: string;
                stack_trace?: string;
                timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                attachments?: ReturnType<typeof dependency_2.testsystem.v1.common.Attachment.prototype.toObject>[];
                run_id?: string;
                retry_index?: number;
                execution_id?: string;
            } = {};
            if (this.test_id != null) {
                data.test_id = this.test_id;
            }
            if (this.failure_message != null) {
                data.failure_message = this.failure_message;
            }
            if (this.stack_trace != null) {
                data.stack_trace = this.stack_trace;
            }
            if (this.timestamp != null) {
                data.timestamp = this.timestamp.toObject();
            }
            if (this.attachments != null) {
                data.attachments = this.attachments.map((item: dependency_2.testsystem.v1.common.Attachment) => item.toObject());
            }
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.retry_index != null) {
                data.retry_index = this.retry_index;
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.test_id.length)
                writer.writeString(1, this.test_id);
            if (this.failure_message.length)
                writer.writeString(2, this.failure_message);
            if (this.stack_trace.length)
                writer.writeString(3, this.stack_trace);
            if (this.has_timestamp)
                writer.writeMessage(4, this.timestamp, () => this.timestamp.serialize(writer));
            if (this.attachments.length)
                writer.writeRepeatedMessage(5, this.attachments, (item: dependency_2.testsystem.v1.common.Attachment) => item.serialize(writer));
            if (this.run_id.length)
                writer.writeString(6, this.run_id);
            if (this.retry_index != 0)
                writer.writeInt32(7, this.retry_index);
            if (this.execution_id.length)
                writer.writeString(8, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TestFailureEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TestFailureEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.test_id = reader.readString();
                        break;
                    case 2:
                        message.failure_message = reader.readString();
                        break;
                    case 3:
                        message.stack_trace = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.timestamp, () => message.timestamp = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.attachments, () => pb_1.Message.addToRepeatedWrapperField(message, 5, dependency_2.testsystem.v1.common.Attachment.deserialize(reader), dependency_2.testsystem.v1.common.Attachment));
                        break;
                    case 6:
                        message.run_id = reader.readString();
                        break;
                    case 7:
                        message.retry_index = reader.readInt32();
                        break;
                    case 8:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): TestFailureEventRequest {
            return TestFailureEventRequest.deserialize(bytes);
        }
    }
    export class TestErrorEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            test_id?: string;
            error_message?: string;
            stack_trace?: string;
            timestamp?: dependency_1.google.protobuf.Timestamp;
            attachments?: dependency_2.testsystem.v1.common.Attachment[];
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("test_id" in data && data.test_id != undefined) {
                    this.test_id = data.test_id;
                }
                if ("error_message" in data && data.error_message != undefined) {
                    this.error_message = data.error_message;
                }
                if ("stack_trace" in data && data.stack_trace != undefined) {
                    this.stack_trace = data.stack_trace;
                }
                if ("timestamp" in data && data.timestamp != undefined) {
                    this.timestamp = data.timestamp;
                }
                if ("attachments" in data && data.attachments != undefined) {
                    this.attachments = data.attachments;
                }
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("retry_index" in data && data.retry_index != undefined) {
                    this.retry_index = data.retry_index;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
        }
        get test_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set test_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get error_message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set error_message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get stack_trace() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set stack_trace(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get timestamp() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 4) as dependency_1.google.protobuf.Timestamp;
        }
        set timestamp(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get has_timestamp() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get attachments() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_2.testsystem.v1.common.Attachment, 5) as dependency_2.testsystem.v1.common.Attachment[];
        }
        set attachments(value: dependency_2.testsystem.v1.common.Attachment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 5, value);
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get retry_index() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set retry_index(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            test_id?: string;
            error_message?: string;
            stack_trace?: string;
            timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            attachments?: ReturnType<typeof dependency_2.testsystem.v1.common.Attachment.prototype.toObject>[];
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }): TestErrorEventRequest {
            const message = new TestErrorEventRequest({});
            if (data.test_id != null) {
                message.test_id = data.test_id;
            }
            if (data.error_message != null) {
                message.error_message = data.error_message;
            }
            if (data.stack_trace != null) {
                message.stack_trace = data.stack_trace;
            }
            if (data.timestamp != null) {
                message.timestamp = dependency_1.google.protobuf.Timestamp.fromObject(data.timestamp);
            }
            if (data.attachments != null) {
                message.attachments = data.attachments.map(item => dependency_2.testsystem.v1.common.Attachment.fromObject(item));
            }
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.retry_index != null) {
                message.retry_index = data.retry_index;
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                test_id?: string;
                error_message?: string;
                stack_trace?: string;
                timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                attachments?: ReturnType<typeof dependency_2.testsystem.v1.common.Attachment.prototype.toObject>[];
                run_id?: string;
                retry_index?: number;
                execution_id?: string;
            } = {};
            if (this.test_id != null) {
                data.test_id = this.test_id;
            }
            if (this.error_message != null) {
                data.error_message = this.error_message;
            }
            if (this.stack_trace != null) {
                data.stack_trace = this.stack_trace;
            }
            if (this.timestamp != null) {
                data.timestamp = this.timestamp.toObject();
            }
            if (this.attachments != null) {
                data.attachments = this.attachments.map((item: dependency_2.testsystem.v1.common.Attachment) => item.toObject());
            }
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.retry_index != null) {
                data.retry_index = this.retry_index;
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.test_id.length)
                writer.writeString(1, this.test_id);
            if (this.error_message.length)
                writer.writeString(2, this.error_message);
            if (this.stack_trace.length)
                writer.writeString(3, this.stack_trace);
            if (this.has_timestamp)
                writer.writeMessage(4, this.timestamp, () => this.timestamp.serialize(writer));
            if (this.attachments.length)
                writer.writeRepeatedMessage(5, this.attachments, (item: dependency_2.testsystem.v1.common.Attachment) => item.serialize(writer));
            if (this.run_id.length)
                writer.writeString(6, this.run_id);
            if (this.retry_index != 0)
                writer.writeInt32(7, this.retry_index);
            if (this.execution_id.length)
                writer.writeString(8, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TestErrorEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TestErrorEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.test_id = reader.readString();
                        break;
                    case 2:
                        message.error_message = reader.readString();
                        break;
                    case 3:
                        message.stack_trace = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.timestamp, () => message.timestamp = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.attachments, () => pb_1.Message.addToRepeatedWrapperField(message, 5, dependency_2.testsystem.v1.common.Attachment.deserialize(reader), dependency_2.testsystem.v1.common.Attachment));
                        break;
                    case 6:
                        message.run_id = reader.readString();
                        break;
                    case 7:
                        message.retry_index = reader.readInt32();
                        break;
                    case 8:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): TestErrorEventRequest {
            return TestErrorEventRequest.deserialize(bytes);
        }
    }
    export class StdErrorEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            test_id?: string;
            message?: string;
            timestamp?: dependency_1.google.protobuf.Timestamp;
            test_case_run_id?: string;
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("test_id" in data && data.test_id != undefined) {
                    this.test_id = data.test_id;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
                if ("timestamp" in data && data.timestamp != undefined) {
                    this.timestamp = data.timestamp;
                }
                if ("test_case_run_id" in data && data.test_case_run_id != undefined) {
                    this.test_case_run_id = data.test_case_run_id;
                }
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("retry_index" in data && data.retry_index != undefined) {
                    this.retry_index = data.retry_index;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
        }
        get test_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set test_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get timestamp() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 3) as dependency_1.google.protobuf.Timestamp;
        }
        set timestamp(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get has_timestamp() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get test_case_run_id() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set test_case_run_id(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get retry_index() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set retry_index(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            test_id?: string;
            message?: string;
            timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            test_case_run_id?: string;
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }): StdErrorEventRequest {
            const message = new StdErrorEventRequest({});
            if (data.test_id != null) {
                message.test_id = data.test_id;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            if (data.timestamp != null) {
                message.timestamp = dependency_1.google.protobuf.Timestamp.fromObject(data.timestamp);
            }
            if (data.test_case_run_id != null) {
                message.test_case_run_id = data.test_case_run_id;
            }
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.retry_index != null) {
                message.retry_index = data.retry_index;
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                test_id?: string;
                message?: string;
                timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                test_case_run_id?: string;
                run_id?: string;
                retry_index?: number;
                execution_id?: string;
            } = {};
            if (this.test_id != null) {
                data.test_id = this.test_id;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            if (this.timestamp != null) {
                data.timestamp = this.timestamp.toObject();
            }
            if (this.test_case_run_id != null) {
                data.test_case_run_id = this.test_case_run_id;
            }
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.retry_index != null) {
                data.retry_index = this.retry_index;
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.test_id.length)
                writer.writeString(1, this.test_id);
            if (this.message.length)
                writer.writeString(2, this.message);
            if (this.has_timestamp)
                writer.writeMessage(3, this.timestamp, () => this.timestamp.serialize(writer));
            if (this.test_case_run_id.length)
                writer.writeString(4, this.test_case_run_id);
            if (this.run_id.length)
                writer.writeString(5, this.run_id);
            if (this.retry_index != 0)
                writer.writeInt32(6, this.retry_index);
            if (this.execution_id.length)
                writer.writeString(7, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StdErrorEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StdErrorEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.test_id = reader.readString();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.timestamp, () => message.timestamp = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        message.test_case_run_id = reader.readString();
                        break;
                    case 5:
                        message.run_id = reader.readString();
                        break;
                    case 6:
                        message.retry_index = reader.readInt32();
                        break;
                    case 7:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): StdErrorEventRequest {
            return StdErrorEventRequest.deserialize(bytes);
        }
    }
    export class StdOutputEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            test_id?: string;
            message?: string;
            timestamp?: dependency_1.google.protobuf.Timestamp;
            test_case_run_id?: string;
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("test_id" in data && data.test_id != undefined) {
                    this.test_id = data.test_id;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
                if ("timestamp" in data && data.timestamp != undefined) {
                    this.timestamp = data.timestamp;
                }
                if ("test_case_run_id" in data && data.test_case_run_id != undefined) {
                    this.test_case_run_id = data.test_case_run_id;
                }
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("retry_index" in data && data.retry_index != undefined) {
                    this.retry_index = data.retry_index;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
        }
        get test_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set test_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get timestamp() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 3) as dependency_1.google.protobuf.Timestamp;
        }
        set timestamp(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get has_timestamp() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get test_case_run_id() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set test_case_run_id(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get retry_index() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set retry_index(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            test_id?: string;
            message?: string;
            timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            test_case_run_id?: string;
            run_id?: string;
            retry_index?: number;
            execution_id?: string;
        }): StdOutputEventRequest {
            const message = new StdOutputEventRequest({});
            if (data.test_id != null) {
                message.test_id = data.test_id;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            if (data.timestamp != null) {
                message.timestamp = dependency_1.google.protobuf.Timestamp.fromObject(data.timestamp);
            }
            if (data.test_case_run_id != null) {
                message.test_case_run_id = data.test_case_run_id;
            }
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.retry_index != null) {
                message.retry_index = data.retry_index;
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                test_id?: string;
                message?: string;
                timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                test_case_run_id?: string;
                run_id?: string;
                retry_index?: number;
                execution_id?: string;
            } = {};
            if (this.test_id != null) {
                data.test_id = this.test_id;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            if (this.timestamp != null) {
                data.timestamp = this.timestamp.toObject();
            }
            if (this.test_case_run_id != null) {
                data.test_case_run_id = this.test_case_run_id;
            }
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.retry_index != null) {
                data.retry_index = this.retry_index;
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.test_id.length)
                writer.writeString(1, this.test_id);
            if (this.message.length)
                writer.writeString(2, this.message);
            if (this.has_timestamp)
                writer.writeMessage(3, this.timestamp, () => this.timestamp.serialize(writer));
            if (this.test_case_run_id.length)
                writer.writeString(4, this.test_case_run_id);
            if (this.run_id.length)
                writer.writeString(5, this.run_id);
            if (this.retry_index != 0)
                writer.writeInt32(6, this.retry_index);
            if (this.execution_id.length)
                writer.writeString(7, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): StdOutputEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new StdOutputEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.test_id = reader.readString();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.timestamp, () => message.timestamp = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        message.test_case_run_id = reader.readString();
                        break;
                    case 5:
                        message.run_id = reader.readString();
                        break;
                    case 6:
                        message.retry_index = reader.readInt32();
                        break;
                    case 7:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): StdOutputEventRequest {
            return StdOutputEventRequest.deserialize(bytes);
        }
    }
    export class SuiteBeginEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            suite?: dependency_4.testsystem.v1.entities.TestSuiteRun;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("suite" in data && data.suite != undefined) {
                    this.suite = data.suite;
                }
            }
        }
        get suite() {
            return pb_1.Message.getWrapperField(this, dependency_4.testsystem.v1.entities.TestSuiteRun, 1) as dependency_4.testsystem.v1.entities.TestSuiteRun;
        }
        set suite(value: dependency_4.testsystem.v1.entities.TestSuiteRun) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get has_suite() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            suite?: ReturnType<typeof dependency_4.testsystem.v1.entities.TestSuiteRun.prototype.toObject>;
        }): SuiteBeginEventRequest {
            const message = new SuiteBeginEventRequest({});
            if (data.suite != null) {
                message.suite = dependency_4.testsystem.v1.entities.TestSuiteRun.fromObject(data.suite);
            }
            return message;
        }
        toObject() {
            const data: {
                suite?: ReturnType<typeof dependency_4.testsystem.v1.entities.TestSuiteRun.prototype.toObject>;
            } = {};
            if (this.suite != null) {
                data.suite = this.suite.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_suite)
                writer.writeMessage(1, this.suite, () => this.suite.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SuiteBeginEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SuiteBeginEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.suite, () => message.suite = dependency_4.testsystem.v1.entities.TestSuiteRun.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): SuiteBeginEventRequest {
            return SuiteBeginEventRequest.deserialize(bytes);
        }
    }
    export class SuiteEndEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            suite?: dependency_4.testsystem.v1.entities.TestSuiteRun;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("suite" in data && data.suite != undefined) {
                    this.suite = data.suite;
                }
            }
        }
        get suite() {
            return pb_1.Message.getWrapperField(this, dependency_4.testsystem.v1.entities.TestSuiteRun, 1) as dependency_4.testsystem.v1.entities.TestSuiteRun;
        }
        set suite(value: dependency_4.testsystem.v1.entities.TestSuiteRun) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get has_suite() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            suite?: ReturnType<typeof dependency_4.testsystem.v1.entities.TestSuiteRun.prototype.toObject>;
        }): SuiteEndEventRequest {
            const message = new SuiteEndEventRequest({});
            if (data.suite != null) {
                message.suite = dependency_4.testsystem.v1.entities.TestSuiteRun.fromObject(data.suite);
            }
            return message;
        }
        toObject() {
            const data: {
                suite?: ReturnType<typeof dependency_4.testsystem.v1.entities.TestSuiteRun.prototype.toObject>;
            } = {};
            if (this.suite != null) {
                data.suite = this.suite.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.has_suite)
                writer.writeMessage(1, this.suite, () => this.suite.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SuiteEndEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SuiteEndEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.suite, () => message.suite = dependency_4.testsystem.v1.entities.TestSuiteRun.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): SuiteEndEventRequest {
            return SuiteEndEventRequest.deserialize(bytes);
        }
    }
    export class HeartbeatEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            source_id?: string;
            timestamp?: dependency_1.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("source_id" in data && data.source_id != undefined) {
                    this.source_id = data.source_id;
                }
                if ("timestamp" in data && data.timestamp != undefined) {
                    this.timestamp = data.timestamp;
                }
            }
        }
        get source_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set source_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get timestamp() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 2) as dependency_1.google.protobuf.Timestamp;
        }
        set timestamp(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get has_timestamp() {
            return pb_1.Message.getField(this, 2) != null;
        }
        static fromObject(data: {
            source_id?: string;
            timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
        }): HeartbeatEventRequest {
            const message = new HeartbeatEventRequest({});
            if (data.source_id != null) {
                message.source_id = data.source_id;
            }
            if (data.timestamp != null) {
                message.timestamp = dependency_1.google.protobuf.Timestamp.fromObject(data.timestamp);
            }
            return message;
        }
        toObject() {
            const data: {
                source_id?: string;
                timestamp?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.source_id != null) {
                data.source_id = this.source_id;
            }
            if (this.timestamp != null) {
                data.timestamp = this.timestamp.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.source_id.length)
                writer.writeString(1, this.source_id);
            if (this.has_timestamp)
                writer.writeMessage(2, this.timestamp, () => this.timestamp.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): HeartbeatEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new HeartbeatEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.source_id = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.timestamp, () => message.timestamp = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): HeartbeatEventRequest {
            return HeartbeatEventRequest.deserialize(bytes);
        }
    }
    export class ReportRunStartEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            run_id?: string;
            test_suites?: dependency_4.testsystem.v1.entities.TestSuiteRun[];
            total_tests?: number;
            name?: string;
            metadata?: Map<string, string>;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("test_suites" in data && data.test_suites != undefined) {
                    this.test_suites = data.test_suites;
                }
                if ("total_tests" in data && data.total_tests != undefined) {
                    this.total_tests = data.total_tests;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get test_suites() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_4.testsystem.v1.entities.TestSuiteRun, 2) as dependency_4.testsystem.v1.entities.TestSuiteRun[];
        }
        set test_suites(value: dependency_4.testsystem.v1.entities.TestSuiteRun[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        get total_tests() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set total_tests(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 5) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 5, value as any);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        static fromObject(data: {
            run_id?: string;
            test_suites?: ReturnType<typeof dependency_4.testsystem.v1.entities.TestSuiteRun.prototype.toObject>[];
            total_tests?: number;
            name?: string;
            metadata?: {
                [key: string]: string;
            };
            execution_id?: string;
        }): ReportRunStartEventRequest {
            const message = new ReportRunStartEventRequest({});
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.test_suites != null) {
                message.test_suites = data.test_suites.map(item => dependency_4.testsystem.v1.entities.TestSuiteRun.fromObject(item));
            }
            if (data.total_tests != null) {
                message.total_tests = data.total_tests;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                run_id?: string;
                test_suites?: ReturnType<typeof dependency_4.testsystem.v1.entities.TestSuiteRun.prototype.toObject>[];
                total_tests?: number;
                name?: string;
                metadata?: {
                    [key: string]: string;
                };
                execution_id?: string;
            } = {};
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.test_suites != null) {
                data.test_suites = this.test_suites.map((item: dependency_4.testsystem.v1.entities.TestSuiteRun) => item.toObject());
            }
            if (this.total_tests != null) {
                data.total_tests = this.total_tests;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.run_id.length)
                writer.writeString(1, this.run_id);
            if (this.test_suites.length)
                writer.writeRepeatedMessage(2, this.test_suites, (item: dependency_4.testsystem.v1.entities.TestSuiteRun) => item.serialize(writer));
            if (this.total_tests != 0)
                writer.writeInt32(3, this.total_tests);
            if (this.name.length)
                writer.writeString(4, this.name);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(5, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.execution_id.length)
                writer.writeString(6, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ReportRunStartEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ReportRunStartEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.run_id = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.test_suites, () => pb_1.Message.addToRepeatedWrapperField(message, 2, dependency_4.testsystem.v1.entities.TestSuiteRun.deserialize(reader), dependency_4.testsystem.v1.entities.TestSuiteRun));
                        break;
                    case 3:
                        message.total_tests = reader.readInt32();
                        break;
                    case 4:
                        message.name = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 6:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): ReportRunStartEventRequest {
            return ReportRunStartEventRequest.deserialize(bytes);
        }
    }
    export class TestRunEndEventRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            run_id?: string;
            final_status?: dependency_2.testsystem.v1.common.TestStatus;
            start_time?: dependency_1.google.protobuf.Timestamp;
            duration?: dependency_5.google.protobuf.Duration;
            metadata?: Map<string, string>;
            execution_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("run_id" in data && data.run_id != undefined) {
                    this.run_id = data.run_id;
                }
                if ("final_status" in data && data.final_status != undefined) {
                    this.final_status = data.final_status;
                }
                if ("start_time" in data && data.start_time != undefined) {
                    this.start_time = data.start_time;
                }
                if ("duration" in data && data.duration != undefined) {
                    this.duration = data.duration;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("execution_id" in data && data.execution_id != undefined) {
                    this.execution_id = data.execution_id;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get run_id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set run_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get final_status() {
            return pb_1.Message.getFieldWithDefault(this, 2, dependency_2.testsystem.v1.common.TestStatus.UNKNOWN) as dependency_2.testsystem.v1.common.TestStatus;
        }
        set final_status(value: dependency_2.testsystem.v1.common.TestStatus) {
            pb_1.Message.setField(this, 2, value);
        }
        get start_time() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 3) as dependency_1.google.protobuf.Timestamp;
        }
        set start_time(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get has_start_time() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get duration() {
            return pb_1.Message.getWrapperField(this, dependency_5.google.protobuf.Duration, 4) as dependency_5.google.protobuf.Duration;
        }
        set duration(value: dependency_5.google.protobuf.Duration) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get has_duration() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 5) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 5, value as any);
        }
        get execution_id() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set execution_id(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        static fromObject(data: {
            run_id?: string;
            final_status?: dependency_2.testsystem.v1.common.TestStatus;
            start_time?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            duration?: ReturnType<typeof dependency_5.google.protobuf.Duration.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
            execution_id?: string;
        }): TestRunEndEventRequest {
            const message = new TestRunEndEventRequest({});
            if (data.run_id != null) {
                message.run_id = data.run_id;
            }
            if (data.final_status != null) {
                message.final_status = data.final_status;
            }
            if (data.start_time != null) {
                message.start_time = dependency_1.google.protobuf.Timestamp.fromObject(data.start_time);
            }
            if (data.duration != null) {
                message.duration = dependency_5.google.protobuf.Duration.fromObject(data.duration);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.execution_id != null) {
                message.execution_id = data.execution_id;
            }
            return message;
        }
        toObject() {
            const data: {
                run_id?: string;
                final_status?: dependency_2.testsystem.v1.common.TestStatus;
                start_time?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                duration?: ReturnType<typeof dependency_5.google.protobuf.Duration.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
                execution_id?: string;
            } = {};
            if (this.run_id != null) {
                data.run_id = this.run_id;
            }
            if (this.final_status != null) {
                data.final_status = this.final_status;
            }
            if (this.start_time != null) {
                data.start_time = this.start_time.toObject();
            }
            if (this.duration != null) {
                data.duration = this.duration.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.execution_id != null) {
                data.execution_id = this.execution_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.run_id.length)
                writer.writeString(1, this.run_id);
            if (this.final_status != dependency_2.testsystem.v1.common.TestStatus.UNKNOWN)
                writer.writeEnum(2, this.final_status);
            if (this.has_start_time)
                writer.writeMessage(3, this.start_time, () => this.start_time.serialize(writer));
            if (this.has_duration)
                writer.writeMessage(4, this.duration, () => this.duration.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(5, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.execution_id.length)
                writer.writeString(6, this.execution_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TestRunEndEventRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TestRunEndEventRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.run_id = reader.readString();
                        break;
                    case 2:
                        message.final_status = reader.readEnum();
                        break;
                    case 3:
                        reader.readMessage(message.start_time, () => message.start_time = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.duration, () => message.duration = dependency_5.google.protobuf.Duration.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 6:
                        message.execution_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): TestRunEndEventRequest {
            return TestRunEndEventRequest.deserialize(bytes);
        }
    }
}
